import {
  route,
} from '@app/Routing/helpers'
import { accessPermission } from '@access/permissions'

import {
  ALL,
} from '@app/Seller/accessTokens'

const Base = () => import('@app/Seller/Components/Base')
const SetsList = () => import('@app/Seller/Sets/List.vue')

const MODEL = 'sets'

const BASE = `${MODEL}/`
// const u = url => BASE + url

const LIST = ''

export const SETS_PREFIX = `${MODEL}:`
const p = name => SETS_PREFIX + name

export const SETS_BASE_NAME = p('base')
export const SETS_LIST_NAME = p('list')

export function createRoutes(options) {
  return [
    route(BASE, Base, SETS_BASE_NAME, {
      meta: accessPermission(ALL, options),
      redirect: { name: SETS_LIST_NAME },
      children: [
        route(LIST, SetsList, SETS_LIST_NAME, {
          meta: accessPermission(ALL, options),
        }),
      ],
    }),
  ]
}
